const ENABLE_MODALS = 'ENABLE_MODALS';
const CURBSIDE_CONCIERGE_INFO_MODAL = 'CURBSIDE_CONCIERGE_INFO_MODAL';

export {
    ENABLE_MODALS, CURBSIDE_CONCIERGE_INFO_MODAL
};
